import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Detail from './Detail'
import Grid from "@material-ui/core/Grid";

import Utils from 'EurestoFonction/Utils'
import User from 'EurestoClass/User'
import InputSearch from 'EurestoComponents/InputSearch'
import { InputAdornment } from "@material-ui/core";
import Select from "Components/Select";

const getListStyle = isDraggingOver => ({
    border: `1px dashed ${isDraggingOver ? "lightblue" : "transparent"}`,
    height: '100%',
    width: '100%',
    position: 'relative',
    overflow: 'auto',
    minHeight: 'calc(100% - 30px)',
    maxHeight: 'calc(100% - 30px)',
    scrollBehavior: 'smooth'
});

export default React.memo(props => {

    const [resetInput, setResetInput] = useState(Utils.uuidv4())
    const [key, setKey] = useState(Utils.uuidv4())
    const details = useRef(props.details)
    const scrollBottom = useRef(false)
    const autoFocus = useRef(false)
    const type_produit_id = useRef(undefined)

    const indexInsertion = useRef(undefined)

    const onSave = () => {
        props.onChange(details.current, props.name)
    }

    useEffect(() => {
        if (scrollBottom.current) {
            const div = document.getElementById("parent-test");
            div.scrollTop = div.scrollHeight - div.clientHeight;
            scrollBottom.current = false;
        }
    })

    const onChange = useCallback(i => (data, name) => {
        details.current[i][name] = data
        autoFocus.current = false
        onSave()
    }, [])

    const onDelete = useCallback(i => e => {
        e.preventDefault()
        if (details.current[i].guid) {
            details.current.splice(i, 1)
        } else if (details.current[i].delete) {
            details.current[i].delete = false
        } else {
            details.current[i].delete = true
        }
        autoFocus.current = false
        setKey(Utils.uuidv4())
        onSave()
    }, [])

    const etapesPosition = _ => (details.current || []).map((d, i) => d.etape === 1 ? i : -1).filter(d => d !== -1)

    const addEtapeCommentaire = useCallback(index => (data, label, value) => _ => {
        const ep = etapesPosition()

        /*const etapeIndex = ep.indexOf(index)*/
        const etapeIndex = indexInsertion.current !== undefined ? ep.indexOf(indexInsertion.current) : ep.length - 1
        console.log(indexInsertion.current, etapeIndex)

        const i = ep[etapeIndex + 1]

        details.current.push({
            guid: Utils.getRandomNumber(),
            etape: data === 0 && 1 || 0,
            [data === 0 && "libelle" || "commentaire"]: [{
                langue_id: User.User.get().langue_id || 1,
                text: value
            }]
        })
        if (i >= 0) {
            details.current.move(-1, i)
            if (data === 0 && indexInsertion.current !== undefined) {
                indexInsertion.current = i
            }
        } else if (data === 0 && indexInsertion.current !== undefined) {
            indexInsertion.current = details.current.length - 1
        }
        scrollBottom.current = true
        autoFocus.current = true
        type_produit_id.current = undefined
        setResetInput(Utils.uuidv4())
        setKey(Utils.uuidv4())
        onSave()
    }, [])

    const addProduitDetail = useCallback(index => (produit_id, name, data) => {
        const [produit] = data

        const ep = etapesPosition()
        /*const etapeIndex = ep.indexOf(index)*/
        console.log(indexInsertion.current)
        const etapeIndex = indexInsertion.current !== undefined ? ep.indexOf(indexInsertion.current) : ep.length - 1
        const i = ep[etapeIndex + 1]

        if (produit && produit_id) {
            details.current.push({
                guid: Utils.getRandomNumber(),
                etape: 2,
                type_produit_id: produit.type_produit_id,
                taux_perte: produit.taux_perte,
                prix: produit.prix,
                unite_id: produit.unite_id,
                libelle_part_unite: produit.libelle_part_unite,
                libelle_unite: produit.libelle_unite,
                quantite: produit.quantite,
                part: produit.part,
                produit_libelle: produit.libelle,
                produit_id: produit_id,
            })
            if (i >= 0) {
                details.current.move(-1, i)
            }
            scrollBottom.current = true
            autoFocus.current = true
            type_produit_id.current = undefined
            setResetInput(Utils.uuidv4())
            setKey(Utils.uuidv4())
            onSave()
        }
    }, [])

    const moveIndex = useCallback((from) => (move) => {
        const ep = etapesPosition()
        const etapeIndex = ep.indexOf(from)

        if (etapeIndex !== -1) {
            if (move > 0) {
                const i = ep[etapeIndex + 2]
                if (i >= 0) {
                    const nbInStep = ep[etapeIndex + 1] - from
                    Utils.generateArray(nbInStep).map(_ => details.current.move(from, i - 1))
                } else {
                    const nbInStep = ep[etapeIndex + 1] - from
                    Utils.generateArray(nbInStep).map(_ => details.current.move(from, details.current.length - 1))
                }

            } else {
                const i = ep[etapeIndex - 1]
                const iElemMax = ep[etapeIndex + 1]
                if (i >= 0) {
                    const nbInStep = (iElemMax >= 0 ? iElemMax : details.current.length) - from
                    Utils.generateArray(nbInStep).map((_, n) => details.current.move(from + n, i + n))
                }
            }
        } else {
            details.current.move(from, from + move)
        }
        autoFocus.current = false
        setKey(Utils.uuidv4())
        onSave()
    }, [])

    const optionFunc = useCallback((produit, i) => ({
        label: produit.libelle,
        startAdorment: <i className={`ei-gestion_${produit.type_produit_id === 3 && 'famille'
            || produit.type_produit_id === 4 && 'vin'
            || produit.type_produit_id === 5 && 'produit' || 'fiche_technique'}`} />,
        value: produit.id,
        html: <strong><i className={`ei-gestion_${produit.type_produit_id === 3 && 'famille'
            || produit.type_produit_id === 4 && 'vin'
            || produit.type_produit_id === 5 && 'produit' || 'fiche_technique'}`} />{produit.libelle}</strong>
    }), [])

    const listingDetail = useMemo(() => {
        let lastIndexStepFound = -1;
        return details.current.map((item, index) => {
            let indexProduitEtape = 0
            const ep = etapesPosition()
            if (item.produit_id) {
                if (lastIndexStepFound === -1) {
                    indexProduitEtape = index + 1
                } else {
                    const nbComInStep = details.current.filter((it, ind) => ind < index && ind > lastIndexStepFound && (it.etape === 0 && !it.produit_id))
                    indexProduitEtape = index - lastIndexStepFound - nbComInStep.length
                }
            } else if (item.etape === 1) {
                lastIndexStepFound = index;
            }
            return (
                <Detail
                    lastIndexStepFound={lastIndexStepFound === index ? -1 : lastIndexStepFound}
                    {
                    ...item.etape === 1 && { addEtapeCommentaire: addEtapeCommentaire(index), addProduitDetail: addProduitDetail(index) }
                    }
                    disabled={props.disabled}
                    key={(item.guid || item.id) + '-' + index}
                    lastIndex={details.current.length === (index + 1) || ep.slice(-1)[0] === index}
                    move={moveIndex(index)}
                    autoFocus={autoFocus.current && details.current.length === (index + 1)}
                    index={indexProduitEtape}
                    produit_id={item.produit_id}
                    i={ep[0] === index ? 0 : index}
                    detail={item}
                    onDelete={onDelete(index)}
                    onChange={onChange(index)} />
            )
        }
        )
    }, [details.current, key])

    return (
        <Grid container spacing={0} direction={"column"} wrap={"nowrap"}
            style={Object.assign({
                margin: 0,
                padding: 10,
                position: 'relative',
                height: User.CalculHeight.getHeightWanted(62),
                maxHeight: User.CalculHeight.getHeightWanted(62),
                overflow: 'hidden',
            }, props.style || {})}
            justify={'flex-start'} alignContent={'flex-start'} alignItems={'flex-start'}>
            <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
                <Grid item style={{ width: 'calc(100% - 625px)', minWidth: 200, margin: 0, padding: 2.5 }}>
                    {!props.disabled && <InputSearch
                        optionFunc={optionFunc}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">
                                <Select value={type_produit_id.current}
                                    style={{ width: 60 }}
                                    placeholder={EurestoI18n.t('commun:Filtrer')}
                                    inputStyle={{ marginBottom: 0 }}
                                    disabled={props.disabled}
                                    MenuProps={{
                                        style: { width: 208 }
                                    }}
                                    autoComplete={false}
                                    onChange={(d) => {
                                        console.log(d)
                                        type_produit_id.current = d
                                        setResetInput(Utils.uuidv4())
                                    }}
                                    options={[{
                                        label: 'produit_stock',
                                        customLabel: <i className={'ei-gestion_famille'} />,
                                        html: <span><i className={'ei-gestion_famille'} />Produit en stock</span>,
                                        value: 3
                                    }, {
                                        label: 'ft_base',
                                        customLabel: <i className={'ei-gestion_produit'} />,
                                        html: <span><i className={'ei-gestion_produit'} />FT Base</span>,
                                        value: 5
                                    }, {
                                        label: 'produit_ft',
                                        customLabel: <i className={'ei-gestion_produit'} />,
                                        html: <span><i className={'ei-gestion_fiche_technique'} />Produit & FT</span>,
                                        value: 1
                                    }, {
                                        label: 'produit_vin',
                                        customLabel: <i className={'ei-gestion_vin'} />,
                                        html: <span><i className={'ei-gestion_vin'} />Vin</span>,
                                        value: 4
                                    },]}
                                />
                            </InputAdornment>
                        }}
                        menuMaxHeight={196}
                        placeholder={EurestoI18n.t('commun:Insérer un produit, une étape ou un commentaire')}
                        disabled={props.disabled}
                        MenuProps={{
                            style: { width: 300 }
                        }}
                        recherche={{
                            ...(type_produit_id.current && { type_produit_id: type_produit_id.current === 1 && [1, 2] || type_produit_id.current }),
                            ...(props.produit_id && {
                                id: [props.produit_id],
                                id_non: true
                            }),
                        }}
                        style={{ marginBottom: 0 }}
                        limit={15}
                        options={[{
                            label: 'Étape',
                            value: 0,
                            html:
                                <Grid container justify={'center'} alignContent={'center'} alignItems={'center'}>
                                    <i className={'ei-commun_ajouter EurestoPrimary EurestoText--text'} style={{
                                        padding: '4px 3px 3px 3px',
                                        borderRadius: '50%',
                                        fontSize: 8,
                                        fontWeight: 'bold'
                                    }} />&nbsp;
                                        <strong>Étape</strong></Grid>,
                            onClick: addEtapeCommentaire(-1),
                            resetOnClicked: true
                        }, {
                            label: 'Commentaire',
                            value: -1,
                            html:
                                <Grid container justify={'center'} alignContent={'center'} alignItems={'center'}>
                                    <i className={'ei-commun_ajouter EurestoPrimary EurestoText--text'} style={{
                                        padding: '4px 3px 3px 3px',
                                        borderRadius: '50%',
                                        fontSize: 8,
                                        fontWeight: 'bold'
                                    }} />&nbsp;
                                        <strong>Commentaire</strong></Grid>,
                            onClick: addEtapeCommentaire(-1),
                            resetOnClicked: true
                        }]}
                        onChange={addProduitDetail(-1)} path={'gestion'} requete={'produit'} search={'libelle'}
                        id={'id'}
                        resetInput={resetInput} />}
                </Grid>
                <Grid item style={{ width: 80, margin: 0, padding: 2.5 }}>
                    {!props.disabled && <Select value={indexInsertion.current}
                        disabled={props.disabled}
                        autoComplete={false}
                        inputStyle={{ marginBottom: 0, textAlign: 'center' }}
                        onChange={(d) => {
                            indexInsertion.current = d
                        }}
                        options={[
                            ...(etapesPosition().map((e, i) => ({
                                label: `Étape ${i + 1}`,
                                value: e
                            }))),
                            { label: 'À la fin', value: undefined },
                            { label: 'Au début', value: -1 }
                        ]}
                    />}
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 125 }}>
                    <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                        style={{ margin: 0, padding: 0, height: '100%', fontWeight: 600 }} spacing={0}>
                        Quantité
                        </Grid>
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 50 }}>
                    <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                        style={{ margin: 0, padding: 0, height: '100%', fontWeight: 600 }} spacing={0}>
                        %perte
                        </Grid>
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 175 }}>
                    <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                        style={{ margin: 0, padding: 0, height: '100%', fontWeight: 600 }} spacing={0}>
                        Prix PMP
                        </Grid>
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 75 }}>
                    <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                        style={{ margin: 0, padding: 0, height: '100%', fontWeight: 600 }} spacing={0}>
                        Prix Total
                        </Grid>
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 60 }}>
                    <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                        style={{ margin: 0, padding: 0, height: '100%', fontWeight: 600 }} spacing={0}>
                        Mémo
                        </Grid>
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 60 }}>
                    <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                        style={{ margin: 0, padding: 0, height: '100%', fontWeight: 600 }} spacing={0}>
                        Actions
                        </Grid>
                </Grid>
            </Grid>
            <div
                id={'parent-test'}
                style={getListStyle()}
            >
                {
                    props.disabled && <div style={{
                        height: '100%',
                        width: '100%',
                        zIndex: 10,
                        backgroundColor: 'transparent',
                        opacity: .25,
                        position: 'absolute'
                    }} />
                }
                {listingDetail}
            </div>
        </Grid>)
})


// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Details/index.js